/**
 * Utility functions for session error detection and handling
 */

/**
 * Determines if an error is session-related
 * @param {Error} error - The error to check
 * @returns {boolean} - True if the error is session-related
 */
export function isSessionError(error) {
  if (!error) return false;

  return (
    error?.status === 401 ||
    error?.code === "UNAUTHORIZED" ||
    error?.message?.toLowerCase().includes("session") ||
    error?.message?.toLowerCase().includes("expired") ||
    error?.message?.toLowerCase().includes("invalid") ||
    error?.message?.toLowerCase().includes("unauthorized")
  );
}

/**
 * Creates a normalized session error object
 * @param {Error} error - The original error
 * @returns {Object} - Normalized session error object
 */
export function createSessionError(error) {
  return {
    message: error?.message || "Your session has expired. Please log in again.",
    status: error?.status || 401,
    code: error?.code || "SESSION_EXPIRED",
    timestamp: new Date().toISOString(),
    originalError: error,
  };
}

/**
 * Handles session errors by showing appropriate UI feedback
 * @param {Function} handleSessionError - The session error handler function
 * @param {Error} error - The error to handle
 * @returns {boolean} - True if the error was handled as a session error
 */
export function handleSessionErrorIfApplicable(handleSessionError, error) {
  if (isSessionError(error)) {
    handleSessionError(createSessionError(error));
    return true;
  }
  return false;
}
